<template>
    <div class="app flex-row align-items-center">
        <div class="container">
            <b-row class="justify-content-center">
                <b-col md="8">
                    <b-card v-if="loading">
                        <spinner></spinner>
                    </b-card>
                    <b-card-group v-if="!loading">
                        <b-card no-body class="p-4">
                            <!-- Logo And providers -->
                            <b-card-body>
                                <h1>
                                    <img
                                        src="/img/brand/ssp-icon/apple-icon-57x57.png"
                                    />
                                    <img
                                        style="width: 175px"
                                        src="/img/brand/ikomm-logo.svg"
                                    />
                                </h1>
                            </b-card-body>

                            <b-card-body>
                                <div>
                                    <a-button
                                        type="primary"
                                        ref="loginWithMsalBtn"
                                        @click="login()"
                                    >
                                        <i class="fa fa-windows" />
                                        <span>
                                            {{ $t('text.signInWithO365') }}
                                        </span>
                                    </a-button>
                                </div>
                            </b-card-body>

                            <b-card-body>
                                <b-alert variant="danger" :show="!!error">
                                    {{ error }}
                                </b-alert>
                            </b-card-body>

                            <b-card-body>
                                <b-button
                                    variant="link"
                                    class="px-0"
                                    href="https://passord.ikommservices.no/"
                                    >{{ $t('text.forgotPassword') }}?</b-button
                                >
                            </b-card-body>
                        </b-card>
                    </b-card-group>
                </b-col>
            </b-row>
        </div>
    </div>
</template>

<script>
export default {
    password_reset_url: 'https://passord.ikommservices.no/', //config.services.password_reset,
    data() {
        return {}
    },

    mounted() {
        if (this.$route.hash == '#error-user-not-found') {
            this.error = 'Sorry, we could not find a user with those credentials'
        }
    },

    created() {},

    methods: {
        login() {
            window.location.href = '/login/microsoft'
        },
    },
}
</script>
